<template>
  <div class="finance-page page-padding-top">
    <top-bar :title="i18n.t('finance.title')" @back="back" ></top-bar>

    <div class="top-info flex-column-start-center banner2">
      <div class="title">{{$t('finance.desc3')}}</div>
      <div class="sub-title">{{$t('finance.desc4')}}</div>
    </div>

    <div class="finance-info"  @click="toPosition">
      <div class="flex-center-start modal-title">
        <span>{{i18n.t('finance.label1')}}</span>
        <img :src="rightUrl" alt="">
      </div>

      <div class=" statistics">
        <div class="flex statistics-line" >
          <div class="flex-1">
            <div class="label">{{i18n.t('finance.label3')}}(USDT)</div>
            <div class="count">{{statisticsData.Amount ? parseFloat(statisticsData.Amount).toFixed(4) : '0.0000'}}</div>
          </div>
          <div class="flex-1 text-right">
            <div class="label">{{i18n.t('finance.label4')}}(USDT)</div>
            <div class="count">{{statisticsData.Income ? parseFloat(statisticsData.Income).toFixed(4) : '0.0000'}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="page-title">{{$t('finance.title2')}}</div>

    <div class="tabs flex">
      <div class="tab" :class="tabIndex == 1 ? 'active' : ''" @click="changeTab(1)">{{$t('finance.tab1')}}</div>
      <div class="tab" :class="tabIndex == 2 ? 'active' : ''" @click="changeTab(2)">{{$t('finance.tab2')}}</div>
    </div>

    <div class="finance-list">
      <List
        v-if="dataList.length > 0"
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="onLoad">

        <div class="list flex-center-between" v-for="(item, i) in dataList" :key="i" @click="toBuy(item)">

          <div class="flex-center finance-title">
            <img :src="'/upload/' + item.Currency.Logo" alt="">
            <span>{{item.Currency.ShortName}}</span>
          </div>
          <div class="text-right">
            <div class="label">{{i18n.t('finance.label7')}}</div>
            <div class="count">{{item.IncomeRatio}}%</div>
          </div>
        </div>
      </List>
      <div class="empty-box flex-column-center" v-if="dataList == 0 && isInit">
        <img :src="emptyUrl" alt="">
        <span>{{$t('common.empty')}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, List } from 'vant'
import topBar from '@/components/topBar'
import { financeSetupList, financeList, financialStatistics } from '@/api/finance'
export default {
  components: {
    topBar,
    Button,
    List
  },
  data() {
    return {
      rightUrl: require('../../assets/imgs/icon-arrow-right.png'),
      bitUrl: require('../../assets/imgs/bit1.png'),
      emptyUrl: require('../../assets/imgs/order-empty.png'),
      page: {
        page: 1,
        limit: 10
      },
      isInit: false,
      loading: false,
      finished: false,
      totalPage: 1,
      tabIndex: 1,
      finishedText: '',
      financeDataList: [], //申购产品列表
      ownerFinanceList: [], //已申购列表
      statisticsData: {},
      dataList: []
    }
  },
  mounted() {
    this.init()
    this.initStatistics()
  },
  methods: {
    init(isAdd) {
      let form = new FormData()
      form.append('current', this.page.page)
      form.append('pageSize', this.page.limit)
      financeSetupList(form).then(res => {
        if (res.data.Items) {
          let list = res.data.Items.filter(v => {
            return v.Status == 1
          })
          if (isAdd) {
            this.financeDataList = this.financeDataList.concat(list)
          } else {
            this.financeDataList = list
          }
          this.dataList = this.financeDataList.filter(v => {
            return v.ProductType == this.tabIndex
          })
          this.totalPage = res.data.Pagination.totalPage
          if (this.totalPage <= this.page.page) {
             this.finished = true
          }
        }
        this.isInit = true
        this.loading = false

      })
    },
    initStatistics() {
      financialStatistics().then(res => {
        this.statisticsData = res.data
      })
    },
    initFinance() {
      let form = new FormData()
      form.append('current', 1)
      form.append('pageSize', 100)
      financeList().then(res => {
        this.ownerFinanceList = res.data.Items
      })
    },
    onLoad() {
      this.page.page += 1
      this.init(true)
    },
    toDetail(data) {
      sessionStorage.setItem('financeData', JSON.stringify(data))
      this.$router.push({
        path: '/financeDetail',
      })
    },
    toPosition() {
      this.$router.push({
        name: 'myPosition'
      })
    },
    changeTab(i) {
      this.tabIndex = i
      this.page.page = 1
      this.dataList = this.financeDataList.filter(v => {
        return v.ProductType == this.tabIndex
      })
      // this.init()
    },
    toBuy(data) {
      sessionStorage.setItem('financeData', JSON.stringify(data))
      this.$router.push({
        path: '/financeBuy',
      })
    },
    back() {
      this.$router.go(-1)
    }
  }
}
</script>